export default class SDError extends Error {
  type = 'error';
}



// WEBPACK FOOTER //
// ./src/model/SDError.js